
import React from 'react';
import MainLayout from '@/components/layout/MainLayout';
import HeroSection from '@/components/landing/HeroSection';
import ReferralPromoImage from '@/components/landing/ReferralPromoImage';
import FeaturesSection from '@/components/landing/FeaturesSection';
import TestimonialsSection from '@/components/landing/TestimonialsSection';
import CTASection from '@/components/landing/CTASection';
import SaasPromoBanner from '@/components/landing/SaasPromoBanner';
import PricingCTA from '@/components/landing/PricingCTA';
import SEO from '@/components/SEO';
import DetailedFeatures from '@/components/landing/DetailedFeatures';
import DashboardFeatures from '@/components/landing/DashboardFeatures';
import IntegrationsSection from '@/components/landing/IntegrationsSection';
import BenefitsSection from '@/components/landing/BenefitsSection';

const Index: React.FC = () => {
  return (
    <>
      <SEO 
        title="ReferMe | Grow Your Business With Referrals"
        description="Transform your customer base through powerful referral marketing. Our platform makes it easy to track, manage, and reward customer referrals."
        keywords="referral marketing, customer referrals, referral program, word of mouth marketing, referral tracking"
      />
      <MainLayout isLoggedIn={false}>
        <HeroSection />
        <ReferralPromoImage />
        <FeaturesSection />
        <DetailedFeatures />
        <DashboardFeatures />
        <IntegrationsSection />
        <BenefitsSection />
        <TestimonialsSection />
        <CTASection />
        <SaasPromoBanner />
        <PricingCTA />
      </MainLayout>
    </>
  );
};

export default Index;
